import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { tableMessages as messages } from '@atlaskit/editor-common/messages';
import Tooltip from '@atlaskit/tooltip';
import { TableCssClassName } from '../../types';
export var ColumnResizeWidget = function ColumnResizeWidget(_ref) {
  var startIndex = _ref.startIndex,
    endIndex = _ref.endIndex,
    includeTooltip = _ref.includeTooltip;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if (!includeTooltip) {
    return jsx("div", {
      className: TableCssClassName.RESIZE_HANDLE_DECORATION,
      "data-start-index": startIndex,
      "data-end-index": endIndex
    });
  }
  return jsx(Tooltip, {
    content: formatMessage(messages.adjustColumns),
    hideTooltipOnClick: true,
    hideTooltipOnMouseDown: true,
    position: "mouse",
    mousePosition: "auto-start"
  }, function (tooltipProps) {
    return jsx("div", _extends({
      className: TableCssClassName.RESIZE_HANDLE_DECORATION,
      "data-start-index": startIndex,
      "data-end-index": endIndex
    }, tooltipProps));
  });
};